import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default function () {
  const targetDataSpeed = gsap.utils.toArray('[data-speed]')
  const { isMobileOrTablet } = useDevice()

  const multiplier = isMobileOrTablet ? 1000 : 100

  if (targetDataSpeed.length > 0) {
    targetDataSpeed.forEach((el) => {
      gsap.to(el, {
        y: el.getAttribute('data-speed') * multiplier,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: window.innerHeight + 'px',
          invalidateOnRefresh: true,
          scrub: true
        }
      })
    })
  }
  ScrollTrigger.refresh()
}
